/* globals ga */
'use strict';
/**
 * Service: Analytics
 *
 * Used to initialize the analytics and set the deployment token.
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export wdAnalytics for ES6 usage
 *          1.8.1 #203 Add google analytics to main-library-js
 *
 * @author Dallas Vogels <dvogels@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 *
 * @copyright (c) 2015-2020 Build Centrix
 */
var wdAnalytics = angular.module('wd.service.analytics', [])
    .factory('wdAnalytics',
        [
            '$window',
            function ($window) {

                /**
                 * @since 1.8.1 #203 Add google analytics to main-library-js
                 *
                 * @type {{}}
                 */
                var service = {};

                /**
                 * Set Deployment Token
                 *
                 * Checks for the google analytics object and sets the deployment accordingly.
                 *
                 * @since 1.8.1 #203 Add google analytics to main-library-js
                 *
                 * @param {string} deploymentToken
                 *
                 * @returns {boolean}
                 */
                function setDeploymentToken(deploymentToken)
                {
                    var result = false;

                    if ($window.ga) {
                        ga('set', 'Deployment', deploymentToken);
                        result = true;
                    }

                    return result;
                }

                /**
                 * Initialize Analytics
                 *
                 * @since 1.8.1 #203 Add google analytics to main-library-js
                 *
                 * @param {string} deploymentToken
                 *
                 * @returns {boolean}
                 */
                service.initializeAnalytics = function (deploymentToken)
                {
                    var result;

                    result = setDeploymentToken(deploymentToken);

                    return result;
                };

                return service;

            }]);
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdAnalytics;
}            

// EOF
